import CardComponent from './CardComponent';

export class MarketplaceEnquiriesFeedback extends CardComponent {}
